module.exports = __webpack_public_path__ + "img/ce_simple_white.8ea3c482.png";